import slice from './slice';

const { reducer } = slice;

export * from './actions';
export * from './selectors';
export { reducer as OrderPageReducer };